export default __webpack_public_path__ + "static/media/IMG-20240708-WA0008.f6556905.jpg";